import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import supabase from "../config/supabaseClient";
import { useYear } from "../YearContext"; 
import '../CreateTalkArchive.css';

const Create_game = () => {
  const navigate = useNavigate();
  const { year } = useYear();

  const [year_id, setYear_id] = useState(null);
  const [Journey, setJourney] = useState('');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [weather, setWeather] = useState('');
  const [temperature, setTemperature] = useState('');
  const [tot_min, setTot_min] = useState('');
  const [formation, setFormation] = useState('');
  const [adversaryName, setAdversaryName] = useState('');
  const [formError, setFormError] = useState(null);
  const [adversaries, setAdversaries] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [selectedAdversaryId, setSelectedAdversaryId] = useState(null);
  const [groups, setGroups] = useState([]);
  const [selectedGroupId, setSelectedGroupId] = useState('');

  // ✅ Formation layouts
  const formationLayouts = {
    "4-3-3": [4, 3, 3],
    "4-4-2": [4, 4, 2],
    "3-5-2": [3, 5, 2],
    "3-4-3": [3, 4, 3],
    "4-2-3-1": [4, 2, 3, 1],
    "5-3-2": [5, 3, 2],
    "5-4-1": [5, 4, 1],
    "4-5-1": [4, 5, 1],
    "3-6-1": [3, 6, 1],
    "4-1-4-1": [4, 1, 4, 1],
    "4-1-3-2": [4, 1, 3, 2],
    "4-2-2-2": [4, 2, 2, 2],
    "3-3-4": [3, 3, 4],
    "4-3-2-1": [4, 3, 2, 1],
    "3-2-3-2": [3, 2, 3, 2],
    "3-2-2-3": [3, 2, 2, 3],
    "2-3-5": [2, 3, 5],
    "WM (3-2-2-3)": [3, 2, 2, 3],
    "4-2-4": [4, 2, 4],
    "3-4-1-2": [3, 4, 1, 2]
  };

  // Fetch year_id
  useEffect(() => {
    const fetchYearId = async () => {
      try {
        const { data, error } = await supabase
          .from("year")
          .select("id")
          .eq("year", year)
          .single();

        if (error) throw error;
        setYear_id(data?.id);
      } catch (err) {
        console.error("Error fetching year_id:", err);
        setFormError("Could not load year information.");
      }
    };
    fetchYearId();
  }, [year]);

  // Fetch adversaries
  useEffect(() => {
    const fetchAdversaries = async () => {
      const { data, error } = await supabase
        .from('adversaries')
        .select('id, Adversarie');

      if (error) {
        console.error('Error fetching adversaries:', error);
        return;
      }
      setAdversaries(data || []);
    };
    fetchAdversaries();
  }, []);

  // Fetch adversary suggestions
  useEffect(() => {
    const fetchSuggestions = async () => {
      if (adversaryName) {
        const { data, error } = await supabase
          .from('adversaries')
          .select('id, Adversarie')
          .ilike('Adversarie', `%${adversaryName}%`);

        if (error) {
          console.error('Error fetching suggestions:', error);
          return;
        }
        setSuggestions(data || []);
      } else {
        setSuggestions([]);
      }
    };
    fetchSuggestions();
  }, [adversaryName]);

  // Fetch groups
  useEffect(() => {
    const fetchGroups = async () => {
      const { data, error } = await supabase
        .from('groups')
        .select('id, name');

      if (error) {
        console.error('Error fetching groups:', error);
        return;
      }
      setGroups(data || []);
    };
    fetchGroups();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!year_id || !Journey || !date || !time || !weather || !temperature || !tot_min || !formation || !selectedAdversaryId || !selectedGroupId) {
      setFormError('Please fill in all required fields.');
      return;
    }

    try {
      const { error } = await supabase
        .from('game')
        .insert([{
          year_id,
          Journey,
          Date: date,
          Time: time,
          Weather: weather,
          Temperature: temperature,
          tot_min,
          formation,
          Adversarie_id: selectedAdversaryId,
          group_id: selectedGroupId
        }]);

      if (error) {
        console.error('Supabase error:', error);
        setFormError('Error inserting the data. ' + (error.message || 'Unknown error'));
      } else {
        setFormError(null);
        navigate('/games', { replace: true });
      }
    } catch (err) {
      console.error('Unexpected error:', err);
      setFormError('Unexpected error occurred. ' + (err.message || 'Unknown error'));
    }
  };

  return (
    <div className="page create">
      <form onSubmit={handleSubmit}>
        {/* Show year */}
        <div className="form-group">
          <p><strong>Year:</strong> {year}</p>
        </div>

        {/* Journey */}
        <div className="form-group">
          <label htmlFor="Journey">Journey:</label>
          <input
            type="text"
            id="Journey"
            value={Journey}
            onChange={(e) => setJourney(e.target.value)}
          />
        </div>

        {/* Date */}
        <div className="form-group">
          <label htmlFor="date">Date:</label>
          <input
            type="date"
            id="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
        </div>

        {/* Time */}
        <div className="form-group">
          <label htmlFor="time">Time:</label>
          <input
            type="time"
            id="time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
          />
        </div>

        {/* Weather */}
        <div className="form-group">
          <label htmlFor="weather">Weather:</label>
          <input
            type="text"
            id="weather"
            value={weather}
            onChange={(e) => setWeather(e.target.value)}
          />
        </div>

        {/* Temperature */}
        <div className="form-group">
          <label htmlFor="temperature">Temperature:</label>
          <input
            type="number"
            id="temperature"
            value={temperature}
            onChange={(e) => setTemperature(e.target.value)}
          />
        </div>

        {/* Total Minutes */}
        <div className="form-group">
          <label htmlFor="tot_min">Total Minutes:</label>
          <input
            type="number"
            id="tot_min"
            value={tot_min}
            onChange={(e) => setTot_min(e.target.value)}
          />
        </div>

        {/* Formation */}
        <div className="form-group">
          <label htmlFor="formation">Formation:</label>
          <select
            id="formation"
            value={formation}
            onChange={(e) => setFormation(e.target.value)}
          >
            <option value="">-- Select Formation --</option>
            {Object.keys(formationLayouts).map((f) => (
              <option key={f} value={f}>{f}</option>
            ))}
          </select>
        </div>

        {/* Mini pitch */}
        {formation && (
          <div className="mini-pitch">
            {formationLayouts[formation].map((line, i) => (
              <div key={i} className="line">
                {Array.from({ length: line }).map((_, j) => (
                  <div key={j} className="player-dot"></div>
                ))}
              </div>
            ))}
          </div>
        )}

        {/* Adversary Autocomplete */}
        <div className="form-group">
          <label htmlFor="adversary">Adversary:</label>
          <input
            type="text"
            id="adversary"
            value={adversaryName}
            onChange={(e) => {
              setAdversaryName(e.target.value);
              setSelectedAdversaryId(null);
            }}
          />
          <ul className="suggestions-list">
            {suggestions.map((suggestion) => (
              <li
                key={suggestion.id}
                onClick={() => {
                  setAdversaryName(suggestion.Adversarie);
                  setSelectedAdversaryId(suggestion.id);
                  setSuggestions([]);
                }}
              >
                {suggestion.Adversarie}
              </li>
            ))}
          </ul>
        </div>

        {/* Group Selector */}
        <div className="form-group">
          <label htmlFor="group">Group:</label>
          <select
            id="group"
            value={selectedGroupId}
            onChange={(e) => setSelectedGroupId(e.target.value)}
          >
            <option value="">-- Select Group --</option>
            {groups.map((group) => (
              <option key={group.id} value={group.id}>
                {group.name}
              </option>
            ))}
          </select>
        </div>

        {/* Submit */}
        <div className="form-group">
          <button type="submit">Submit</button>
        </div>

        {/* Error */}
        {formError && <p className="error">{formError}</p>}
      </form>

      {/* Pitch styling */}
      <style>{`
        .mini-pitch {
          background: green;
          border: 2px solid white;
          border-radius: 10px;
          width: 200px;
          height: 300px;
          margin: 15px auto;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          padding: 10px;
        }
        .line {
          display: flex;
          justify-content: center;
          gap: 10px;
        }
        .player-dot {
          width: 18px;
          height: 18px;
          background: white;
          border-radius: 50%;
        }
      `}</style>
    </div>
  );
};

export default Create_game;
